// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientsUI_view__sO3ei {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ClientsUI_loader__2EyIj {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ClientsUI_edit__n9gvx,
.ClientsUI_delete__mNxsR {
  cursor: pointer;
  margin-top: 3px;
}

.ClientsUI_actions__D7BY8 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ClientsUI_divider__WRoGt {
  width: 1px;
  background-color: #c9c9c9;
  height: 22px;
  margin: 0 15px;
}

.ClientsUI_watch__phoug {
  color: var(--orange);
}

.ClientsUI_eye__guWEt {
  width: 20px;
  height: 20px;
}

.ClientsUI_antForm__DI7Nj{
  display: grid;
  grid-template-columns: repeat(3,200px);
  gap:50px;
  width: 100%;
}

.ClientsUI_label__ON0ki {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.ClientsUI_input__h7r7N,
.ClientsUI_input__h7r7N .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.ClientsUI_itemColumn__KnuO5 {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.ClientsUI_submit__mc3pS {
  width: 175px;
  font-weight: 700;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/pages/clients/styles/ClientsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.edit,\n.delete {\n  cursor: pointer;\n  margin-top: 3px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.divider {\n  width: 1px;\n  background-color: #c9c9c9;\n  height: 22px;\n  margin: 0 15px;\n}\n\n.watch {\n  color: var(--orange);\n}\n\n.eye {\n  width: 20px;\n  height: 20px;\n}\n\n.antForm{\n  display: grid;\n  grid-template-columns: repeat(3,200px);\n  gap:50px;\n  width: 100%;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.itemColumn {\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.submit {\n  width: 175px;\n  font-weight: 700;\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ClientsUI_view__sO3ei`,
	"loader": `ClientsUI_loader__2EyIj`,
	"edit": `ClientsUI_edit__n9gvx`,
	"delete": `ClientsUI_delete__mNxsR`,
	"actions": `ClientsUI_actions__D7BY8`,
	"divider": `ClientsUI_divider__WRoGt`,
	"watch": `ClientsUI_watch__phoug`,
	"eye": `ClientsUI_eye__guWEt`,
	"antForm": `ClientsUI_antForm__DI7Nj`,
	"label": `ClientsUI_label__ON0ki`,
	"input": `ClientsUI_input__h7r7N`,
	"itemColumn": `ClientsUI_itemColumn__KnuO5`,
	"submit": `ClientsUI_submit__mc3pS`
};
export default ___CSS_LOADER_EXPORT___;
